<template>
  <span v-if="workingApplication.personalDetails !== undefined">
    Χρήστης:
    <span style="font-weight: bold">
      {{workingApplication.personalDetails.name}}
      {{workingApplication.personalDetails.surname}},
    </span><br>
    Τύπος:
    <span style="font-weight: bold">
      {{ applicationTypeDescription(workingApplication.applicationType, workingApplication.reappraisalSecondDegree) }}
    </span>
    <span style="font-weight: bold">{{translate(workingApplication.degreeType)}}</span>
     <span style="font-weight: bold" v-if="workingApplication.degreeType === 'bachelor'">
      {{workingApplication.correspondence
        ? ' με Ακαδημαϊκή Ισοδυναμία' : ' '}}
    </span>
    <span style="font-weight: bold" v-if="workingApplication.degreeType === 'bachelor'">
      {{workingApplication.consideration
        ? 'με Συνυποβολή τίτλου 2ου κύκλου σπουδών' : 'χωρίς Συνυποβολή'}}
    </span><br>
    <!-- <span style="font-weight: bold" v-if="workingApplication.degreeType === 'master'">
      {{workingApplication.scoreMatch
        ? 'με Βαθμολογικη Αντιστοιχία,' : 'χωρίς Βαθμολογικη Αντιστοιχία,'}}
    </span> -->
    <!-- <span v-if="workingApplication.id !== null">
       Αριθμός Αίτησης:
      <span style="font-weight: bold" >
           {{workingApplication.applicationType === 'recognition'
              ? workingApplication.id
              : workingApplication.relevantAppl.id }}
      </span>
      <span v-if="workingApplication.reappraisalSecondDegree">
        (Σχετ. επανεξέταση υπ' αρ.:
           {{workingApplication.relevantReappraisalAppl.id}})
      </span>
    </span> -->
    <span v-if="workingApplication.protocol !== null">
       Αριθμός Πρωτοκόλλου:
      <span style="font-weight: bold" >
          {{workingApplication.protocol}}
      </span>
    </span>
    <span style="font-weight: bold; color:red" v-else>
      <br>Προσοχή: Η αίτηση δεν έχει αριθμό πρωτοκόλλου. Θα οριστεί αυτόματα κατά την οριστική υποβολή της από τον προέλεγχο.
    </span>
    <span v-if="workingApplication.praxeisNo !== null">
      , Αριθμός Πράξης:
      <span style="font-weight: bold">
          {{workingApplication.praxeisNo}}
      </span>
    </span>
    <span v-if="recognized">
      , Ημερομηνία Αναγνώρισης:
      <span style="font-weight: bold">
          {{dateRecognized}}
      </span>
    </span>
    <span v-if="received">
      , Ημερομηνία Παραλαβής:
      <span style="font-weight: bold">
          {{dateReceived}}
      </span>
    </span>
  </span>
</template>

<script>
import { mapState } from 'vuex'
import dictionary from '../../store/dictionary'

export default {
  components: {
    dictionary
  },
  mounted: function () {
  },
  data () {
    return {
    }
  },
  methods: {
    applicationTypeDescription (appType, secondReappraisal) {
      switch (appType) {
        case 'recognition':
          return 'Αναγνώριση για'
        case 'reappraisal':
          if (secondReappraisal) {
            return 'Δεύτερη επανεξέταση'
          }
          return 'Επανεξέταση'
        case 'compensatory':
          return 'Έκδοση Πράξης μετά από εξετάσεις'
      }
      return '---'
    },
    translate (term) {
      return dictionary[term]
    }
  },
  computed: {
    dateRecognized () {
      return this.workingApplication.applicationHistory &&
      this.workingApplication.applicationHistory[this.workingApplication.applicationHistory.length - 1].date !== null &&
      this.workingApplication.applicationHistory[this.workingApplication.applicationHistory.length - 1].applicationStatus === 'president_finalized'
        ? this.workingApplication.applicationHistory[this.workingApplication.applicationHistory.length - 1].date.substring(0, 10) : '-'
    },
    recognized () {
      return this.workingApplication.applicationHistory &&
      this.workingApplication.applicationHistory[this.workingApplication.applicationHistory.length - 1].date !== null &&
      this.workingApplication.applicationHistory[this.workingApplication.applicationHistory.length - 1].applicationStatus === 'president_finalized'
        ? this.workingApplication.applicationHistory[this.workingApplication.applicationHistory.length - 1].date !== null : false
    },
    dateReceived () {
      return this.workingApplication.applicationHistory &&
      this.workingApplication.applicationHistory[this.workingApplication.applicationHistory.length - 1].dateCompleted !== null &&
      this.workingApplication.applicationHistory[this.workingApplication.applicationHistory.length - 1].applicationStatus === 'president_finalized'
        ? this.workingApplication.applicationHistory[this.workingApplication.applicationHistory.length - 1].dateCompleted.substring(0, 10) : '-'
    },
    received () {
      return this.workingApplication.applicationHistory &&
        this.workingApplication.applicationHistory[this.workingApplication.applicationHistory.length - 1].applicationStatus === 'president_finalized' &&
        this.workingApplication.applicationHistory[this.workingApplication.applicationHistory.length - 1].dateCompleted !== null
    },
    ...mapState([
      'workingApplication'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/UserAppInfo.vue